import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { HavePaginationEntity } from 'src/entities/HavePagination.entity';
import { TruckEntity as Entity } from 'src/entities/truckEntity';

const requestPathBase = '/api/v4/master/trucks';
export const queryKey = 'useTrucksRequest';

const getResources = async (page: number, sortCondition: string, searchCondition: string, per?: number) => {
  const requestParams = [
    `page=${page + 1}`,
    sortCondition ? `sort_condition=${sortCondition}` : '',
    searchCondition ? `${searchCondition}` : '',
    per ? `per=${per}` : '',
  ].filter((maybe) => maybe).join('&');

  const requestPath = [
    requestPathBase,
    requestParams,
  ].join('?');

  const response: AxiosResponse<HavePaginationEntity<Entity>> = await axios.get<HavePaginationEntity<Entity>>(requestPath);

  return response.data;
};

export const useTrucksRequest = (
  page: number,
  sortCondition: string,
  searchCondition: string,
  per?: number,
  options?: Omit<UseQueryOptions<HavePaginationEntity<Entity>>, 'queryKey' | 'queryFn'>
) => useQuery(
  [queryKey, { page, sortCondition, searchCondition, per }],
  () => getResources(page, sortCondition, searchCondition, per),
  options
);
